module.exports = __webpack_public_path__ + "img/alertHeaderRightIcon.0dc06bec.svg";